import { macroAhorro } from './ahorro';
import { macroAhorroDoble } from './ahorro-doble';
import { macroBeneficios } from './beneficios';
import { macroCuotas } from './cuotas';
import { macroCTV } from './ctv';
import { macroGIF } from './gif';
import { macroSacaTuTarjeta } from './saca-tu-tarjeta';
import { macroSelecta } from './selecta';
import { macroSelectaGlass } from './selecta-glass';

export const MACRO_TEMPLATES = [
  macroSelecta,
  macroSelectaGlass,
  macroAhorro,
  macroAhorroDoble,
  macroBeneficios,
  macroCuotas,
  macroCTV,
  macroGIF,
  macroSacaTuTarjeta
];

export * from './ctv';
export * from './gif';
export * from './saca-tu-tarjeta';
export * from './beneficios';
export * from './ahorro';
export * from './cuotas';
export * from './ahorro-doble';
export * from './selecta';
export * from './selecta-glass';
